/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Richtext/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Richtext({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Template/NoteEditor/Content/ContentEditor/Richtext",
  onChange
  
}) {
let noteTemplatesTabNoteTemplateContentValueData = fromData.useDataValue({ viewPath,
context: 'note_templates_tab',
path: 'note_template.content',
})
let noteTemplatesTabNoteTemplateContentChangeData = fromData.useDataChange({ viewPath,
context: 'note_templates_tab',
path: 'note_template.content',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<InlineNoteEditor
  viewPath={`${viewPath}/InlineNoteEditor`}
 containerId="note-template"
 marginTop={dtSpaceXxs}
 marginBottom={0}
 paddingBottom={0}
 paddingTop={0}
 paddingLeft={0}
 paddingRight={0}
 width="100%"
 height={550}
 inline={false}
 data="note_templates_tab.note_template.content"
 value={noteTemplatesTabNoteTemplateContentValueData}
 onChange={noteTemplatesTabNoteTemplateContentChangeData}
 toolbarPersist={true}
/>
{children}
</React.Fragment>)
}